import React from "react";
import { SpeechSynthesisProvider } from "../../../hooks/SpeechSynthesisContext";
import NowServing from "./components/NowServing";

export default function NowServingWithSpeech({ nowServing, speechConfig }) {
  return (
    <SpeechSynthesisProvider>
      <NowServing nowServing={nowServing} speechConfig={speechConfig} />
    </SpeechSynthesisProvider>
  );
}
